<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable>
                  <el-option-group
                    label="Site Listesi">
                    <el-option
                      v-for="item in Siteler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                  <el-option-group
                    label="Bina Listesi">
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Proje Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item label="Özel Madde" prop="OzelMadde">
                <el-input type="textarea" v-model="Form.OzelMadde"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>


        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>

          <div class="yazdirtable " style="display:block;">
            <div class="isletmedefteri" id="Indirme1">
              <ul class="isletmelist ">
                <div class="row">
                  <div class="col-6">
                    <div class="cift-border">
                      {{ Logo }}
                      <img v-if="Logo" :src="'https://cdn.mudu.pro/Drive/upload/1/Genel/'+Logo" width="150"
                           class="pull-left">
                      <img v-if="!Logo" src="https://cdn.mudu.pro/Design/logo.svg" width="150" class="pull-left">
                      <div class=" col-lg-4 col-md-4 col-sm-4 col-xs-4 pull-right text-right"><b>MERVE APARTMANI</b><br>
                        Bina İşletme Projesi<br> 04.08.2020
                      </div>
                      <div class="clearfix"></div>
                      <div class="text-center"><br> <b>MERVE APARTMANI 01.10.2015 - 31.12.2020 Dönemi Bina İşletme
                        Projesi'dir. </b> <br>
                      </div>
                      <div class="text-center"> Sayın: CANER ŞEN <br> Beyazşehir Mahallesi 825.Sokak No.11 38125 -
                        Kocasinan / KAYSERİ
                      </div>
                      <br><br>
                      <div style="text-indent:20px;"> Apartmanınızın 22.10.2015 tarihinde yapılan Kat
                        malikleri genel kurulunda ; 26.02.2014 Tarih
                        ve 8223 Yevmiye nolu
                        8 Noterliğinden tasdikli
                        karar defterinizin 8 ve 9 nolu sayfalarındaki karar ile
                        alınan yetkiye istinaden aşağıdaki kararlar alınmıştır.
                      </div>


                      <li> Apartmanınızın tahsilat işi
                        ; 01.10.2015 - 31.12.2020 dönemi için ZİRVE BİNA YÖNETİMİ LTD.ŞTİ'ne yetki verilmiştir.
                      </li>
                      <li> Bina Yönetiminiz ; 35, 3 , 29 ve Denetçi 16 seçili
                        olup, 35 Yönetim Kurulu Başkanı'dır.
                      </li>
                      <li> Aidatlar her ayın 30'u mesai bitimine kadar tahsilat
                        ofisimize bizzat gelerek nakit veya kredi kartı,
                        banka hesaplarımıza veya internet sitemiz üzerinden online ödeme yapılacaktır.
                        Vadesine kadar ödenmeyen aidatlara aylık % 5. gecikme
                        tazminatı uygulanacaktır.
                        Zamanında ödenmeyen aidatlar için yönetime ve bina sakinlerine ayrıca bilgi
                        vermeye gerek olmaksızın icra takibi başlatılacaktır.
                        Ödemeler T.B.K. m.100 gereğince öncelikle gecikme zamlarına sayılacaktır.
                      </li>
                      <li> Piyasa durum ve mevsim şartlarına göre aidat yetersiz kalır ve demirbaş
                        harcamaları olursa aşağıdaki miktarlara ekleme yapılacaktır.
                      </li>
                      <li> Yapılacak olan demirbaş harcamalarının ödemelerini kiracılar yapacak, Mesken
                        sahiplerinden talepte bulunacaklardır.
                      </li>
                      <li> Kesinlik kazanmış İşletme Projesi İCRA İFLAS KANUNU'nun 68. maddesinde
                        belirtilen belgelerden sayılır.
                      </li>
                      <li> Genel giderlere katılım hususunda K.M.K m.20 doğal olarak uygulanacak olup aidat
                        borçlarından K.M.K.m. 18/2 uyarınca Mesken sahipleri ile kiracılar müştereken
                        malikle birlikte yeni malik müştereken ve müteselsilen sorumludur.
                      </li>
                      <li> Meskenden ayrılan kiracıların borç ve alacaklarından Mesken sahibi sorumludur.
                      </li>
                      <li> Ödenmeyen aidatlarla ilgili icra işlemi yapıldığında yönetime ve firmamıza neden
                        bilgi vermediniz diye sorulmayacaktır.
                      </li>
                      <li> Bu işletme projesinde belirtmiş olduğum TC Kimlik no ve telefon numaralarının
                        tarafıma ait olduğunu onaylarım.
                      </li>
                      <li> Önceki dönemden borcu bulunanların bu borçlarını işletme projesinin tebliğ
                        tarihinden yedi gün içerisinde ödemeleri gerekmektedir. Aşağıda yazılı olan eski
                        borç işbu işletme projesiyle kesinlik kazanacak ve icra takibine konu edilebilir
                        hale gelecek olup itiraz olunmayacaktır.
                      </li>
                      <li> Yönetici firma gerek üçüncü şahıslara gerekse bina sakinlerine karşı dava açmaya
                        yetkilidir.
                      </li>
                      <li> Vadesinde ödenmeyen aidatlara aylık % 5. gecikme
                        tazminatı uygulanarak yatırılacak, eksik yatırılan yönetici de olsa İCRA
                        takibine muhatap olacaktır.
                      </li>
                      <li> Bağımsız bölüme oturan ve ayrılan bina sakinleri bu durumlarını firmaya ve
                        Mesken sahiplerine bildireceklerdir. Bağımsız bölüme yeni oturan bina sakini
                        öncelikle binaya olan borçtan sorumlu olacak, ayrılacak bina sakini ise
                        öncelikle binaya olan borcunu kapatacaktır.
                      </li>
                      <li> İcra işlemlerinden dolayı ödenecek olan gecikme zamlarının kaldırılması
                        hususunda yönetim veya firmamız sorumlu değildir. Bu hususta tek yetkili kat
                        malikleri genel kuruludur.
                      </li>
                      <li> Ödemeler T.B.K. m.100 gereğince öncelikle gecikme tazminatı ve fer" ilere mahsup
                        olunacaktır.
                      </li>

                    </div>
                  </div>
                  <div class="col-6">
                    <div class="cift-border">
                      <li v-if="Form.OzelMadde">{{ Form.OzelMadde }}</li>

                      <li>Apartmanınıza
                        ait 01.10.2015 - 31.12.2020 Dönemi Bina İşletme Projesi.
                        <br>
                        <table class="isletmetable table table-bordered">
                          <thead>
                          <tr>
                            <th width="60%">Tahmini Gider Bütçe Oluşumu</th>
                            <th width="20%" class="text-right">Aylık</th>
                            <th width="20%" class="text-right">Yıllık</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td>Sair Giderler</td>
                            <td class="text-right">2.835,00</td>
                            <td class="text-right">34.020,00</td>
                          </tr>
                          <tr>
                            <th>GENEL TOPLAM</th>
                            <th class="text-right">3.075,00</th>
                            <th class="text-right">36.900,00</th>
                          </tr>
                          </tbody>
                        </table>
                      </li>
                      <li>Ödemeler aşağıdaki şekilde belirlenmiştir.<br>
                        <div class="row">
                          <div class="col-6 p-l-0">
                            <table class="isletmetable table table-bordered">
                              <thead>
                              <tr>
                                <th width="80%">Ödeme Türü, Dönemi</th>
                                <th width="20%" class="text-right">Tutar</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td>AİDAT, MART 2020</td>
                                <td class="text-right">110,00</td>
                              </tr>
                              <tr>
                                <td>AİDAT, NİSAN 2020</td>
                                <td class="text-right">130,00</td>
                              </tr>
                              <tr>
                                <td>AİDAT, MAYIS 2020</td>
                                <td class="text-right">130,00</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-6 p-l-0">
                            <table class="isletmetable table table-bordered">
                              <thead>
                              <tr>
                                <th width="80%">Ödeme Türü, Dönemi</th>
                                <th width="20%" class="text-right">Tutar</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td>ISINMA, ISINMA-1704/1505</td>
                                <td class="text-right">57,00</td>
                              </tr>
                              <tr>
                                <td>AİDAT, AĞUSTOS 2020</td>
                                <td class="text-right">130,00</td>
                              </tr>
                              </tbody>
                              <tbody>
                              <tr>
                                <th width="80%"><b>GENEL TOPLAM</b></th>
                                <th width="20%" class="text-right"><b>557,00</b></th>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="clearfix"></div>
                      </li>
                      <li> Daire malik ve sakinine ait istenilen bilgiler,<br>
                        <table class="isletmetable table table-bordered">
                          <thead>
                          <tr>
                            <th width="30%">İSTENİLEN BİLGİ</th>
                            <th width="35%" class="text-center">SAKİN</th>
                            <th width="35%" class="text-center">MALİK</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <th>ADI SOYADI</th>
                            <th style="border-right:1px solid #e4e7ea"></th>
                            <th></th>
                          </tr>
                          <tr>
                            <th>T.C. KİMLİK NO.</th>
                            <th style="border-right:1px solid #e4e7ea"></th>
                            <th></th>
                          </tr>
                          <tr>
                            <th>EV TELEFONU</th>
                            <th style="border-right:1px solid #e4e7ea"></th>
                            <th></th>
                          </tr>
                          <tr>
                            <th>İŞ TELEFONU</th>
                            <th style="border-right:1px solid #e4e7ea"></th>
                            <th></th>
                          </tr>
                          <tr>
                            <th>CEP TELEFONU</th>
                            <th style="border-right:1px solid #e4e7ea"></th>
                            <th></th>
                          </tr>
                          </tbody>
                        </table>
                      </li>
                      <div class="row">
                        <div class="text-center col-6"> TEBLİĞ EDEN<br><br><br></div>
                        <div class="text-center col-6"> TEBELLÜĞ EDEN<br><br><br></div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </ul>
              <div class="clearfix "></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

import Yukleniyor from "../../../components/Doc/Yukleniyor";


export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      DefterTur: '',
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'İşletme Projesi',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Bina_id: null,
        Tarih: [],
        OzelMadde: ''
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },

      Binalar: [],
      Siteler: [],
      tableData: [],
      tableDisplay: false,
      Logo: JSON.parse(localStorage.getItem('_aiHizmet'))['Logo']


    }
  },
  methods: {

    Yazdir() {
      setTimeout(() => {
        window.print();
      }, 100);
    },

    Getir() {

      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.DefterTur = this.Form.Tur == 1 ? 'Gelir Sayfası' : 'Gider Sayfası';
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/defter/'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                this.tableDisplay = true;
                if (this.tableData) this.Yazdir();
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })

    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
    }
  },

}
</script>
<style scoped>
.isletmedefteri {
  height: 740px;
  background: #fff;
  padding: 20px 0 0;
  font-size: 9px !important;
  margin-bottom: 30px;
}

ul.isletmelist {
  list-style-type: decimal-leading-zero;
  text-align: left;
  margin: 0;
  padding: 0;
}

.cift-border {
  border: 5px double #000;
  padding: 5px;
  height: 690px;
}

ul.isletmelist li {
  padding: 1px 0;
  text-align: left;
  margin-left: 20px;
}

.isletmetable {
  margin: 10px -10px;
}

.isletmetable.table > tbody > tr > td, .isletmetable.table > tbody > tr > th, .isletmetable.table > thead > tr > th {
  font-size: 9px !important;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/ozel/proje.vue